<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="2" md="2" cols="12">
                      <v-autocomplete
                        label="Customer"
                        variant="outlined" 
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="customer_id.value.value"
                        :items="getCustomerMapList"
                        :item-title="(item) => item ? `${item.customer.code} - ${item.customer.customer_name ? item.customer.customer_name : item.customer.customer_owner_name ? item.customer.customer_owner_name : ''}` : ''"
                        item-value="customer_id"
                        :error-messages="customer_id.errorMessage.value" 
                        autocomplete="off"
                        clearable>
                      </v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="4" cols="12">
                      <v-autocomplete 
                        label="Sales Person"
                        density="compact"
                        variant="outlined" 
                        bg-color="grey-lighten-4"
                        :items="getBrandList"
                        v-model="sales_by.value.value"
                        :item-title="item => item && item.name"                                                  
                        item-value="id"
                        :error-messages="sales_by.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                      </v-autocomplete>
                    </v-col>


                    <!-- <v-col lg="2" md="2" cols="12">
                      <v-autocomplete 
                      label="Order Category"
                      variant="outlined" 
                      density="compact"
                      bg-color="grey-lighten-4" 
                      v-model="order_category.value.value"
                      :items="[{ name: 'general', display_text: 'General' }, { name: 'production', display_text: 'Production' }]"
                      :item-title="(item) => `${item.display_text}`" 
                      item-value="name"
                      :error-messages="order_category.errorMessage.value" 
                      autocomplete="off"
                      clearable
                      >
                    </v-autocomplete>

                    </v-col> -->

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="6">
                      <v-btn class="bg-brand" type="submit" ref="searchButton"
                        >Search</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Outstanding Report</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <!-- <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        > -->
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="reportData"
                  :loading="loading"
                  :items-per-page="-1"
                  :search="search"
                  :hover="true"
                  class="elevation-1"
                  density="comfortable"
                  hide-default-footer
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.aging="{ item }">
                    {{ getDaysAgo(item.sale_invoices) }}
                  </template>

                  <template #tfoot>
                    <tr class="font-weight-bold">
                      <td colspan="4" class="text-center">Grand Totals:</td>
                      <td class="text-left">{{ totals.total_cbm.toFixed(2) }}</td>
                      <td colspan="2" class="text-center"></td>
                      <td class="text-left">{{ totals.total.toFixed(2) }}</td>
                      <td class="text-left">{{ totals.paid.toFixed(2) }}</td>
                      <td class="text-left">{{ totals.total_paid.toFixed(2) }}</td>
                      <td class="text-center"></td>
                      <td class="text-left">{{ totals.due_amount.toFixed(2) }}</td>
                      <td colspan="3"></td>
                    </tr>
                  </template>

                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { useField, useForm } from "vee-validate";
import { ref } from "vue";
import { useStore } from "vuex";
import * as yup from "yup";
import Axios from "axios";
import { getCustomerSalesOrderReport } from '@/store/api.js'
import { prevDay } from "vuetify/lib/labs/VCalendar/util/timestamp";

export default {
  components: {
  },
  data: () => ({
    itemsPerPage: 2,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    summary: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false, },
      { title: "Order No", align: "center", key: "code", sortable: false, },
      // { title: 'Buyer Name', key: 'customer.customer_name', align: 'left', sortable: false },
      { title: 'Buyer Name', key: 'shop_name', align: 'left', sortable: false },
      //{ title: 'Shipper Name', key: 'supplier.customer_name', align: 'left', sortable: false },
      { title: 'Shipper Name', key: 'shipper_company_name', align: 'left', sortable: false },
      //{ title: 'Total CTN/ BAG/ KG', key: 'total_bag', align: 'left', sortable: false },
      { title: 'Total CBM', key: 'total_cbm', align: 'left', sortable: false },
      { title: 'Invoice No', key: 'sale_invoices.code', align: 'left', sortable: false },
      { title: 'Delivery Date', key: 'sale_invoices.sale_delivery.delivery_date', align: 'center', sortable: false },
      { title: 'Invoice Value', key: 'total', align: 'right', sortable: false },
      { title: 'Advance', key: 'paid', align: 'right', sortable: false },
      { title: 'Total Paid', key: 'total_paid', align: 'right', sortable: false },
      { title: 'Payment Date', key: 'sale_invoices.customer_payments_latest.payment_date', align: 'center', sortable: false },
      { title: 'Total Due', key: 'due_amount', align: 'right', sortable: false },
      { title: 'Aging (Days)', key: 'aging', align: 'center', sortable: false },
      { title: 'Next Payment Date', key: 'next_payment_date', align: 'right', sortable: false }
    ],  
  }),
  watch: {},
  created() {
    if (this.$store.getters.getCustomerMapList.length === 0) {
      this.$store.dispatch("getCustomerMapList");
    }
     if (this.$store.getters.getBrandList.length === 0) {
      this.$store.dispatch("getBrandList");
    }
  },
  computed: {
    getCustomerMapList() {
      return this.$store.getters.getCustomerMapList;
    },
     getBrandList() {
      return this.$store.getters.getBrandList;
    },
    totals() {
      return this.reportData.reduce((acc, cur) => {
        acc.total_cbm += (+cur.total_cbm || 0);
        acc.total += (+cur.total || 0);
        acc.paid += (+cur.paid || 0);
        acc.total_paid += (+cur.total_paid || 0);
        acc.due_amount += (+cur.due_amount || 0);
        return acc;
      }, {
        total_cbm: 0,
        total: 0,
        paid: 0,
        total_paid: 0,
        due_amount: 0
      });
    }
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        from_date: yup.date().nullable().label("From Date"),
        to_date: yup.date().nullable().label("To Date"),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const customer_id = useField("customer_id");
    const sales_by = useField("sales_by");
    const invoice_code = useField('invoice_code');
    const order_category = useField('order_category');
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const reportData = ref([]);
    const summary = ref({});
    const filters = ref({});

    const submit = handleSubmit(async (values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);

      filters.value = {
        customer_id: customer_id.value?.value,
        sales_by: sales_by.value?.value,
        order_category: order_category.value?.value,
        from_date: values.from_date,
        to_date: values.to_date,
      };

      try {
        const { data } = await Axios.post(getCustomerSalesOrderReport, filters.value)
        reportData.value = data.data
        summary.value = data.summary;
      } catch (err) {
        console.error(err)
      } finally {
        loading.value = false
      }
    });

    const formatCurrency = (val) => Number(val || 0).toLocaleString('en-BD', { minimumFractionDigits: 2 })

    return {
      submit,
      from_date,
      to_date,
      customer_id,
      sales_by,
      order_category,
      invoice_code,
      reportData,
      summary,
      filters,
      formatCurrency,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$router.push({
        name: "add-crm-proposal",
        query: { id: item.id },
      });
    },
    getDaysAgo(invoice) {
      const deliveryDate = invoice?.sale_delivery?.delivery_date;
      if (!deliveryDate) return '-';
      const days = Math.floor((new Date() - new Date(deliveryDate)) / 86400000);
      //return days + ' days ago';
      return days + '';
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      this.$exportTableToPDF( columns, rows, "Sale Statement", "sale_statement_reports_" + this.$fileDate() );
    },
    exportToExcel() {
      const data = [
        [
          "#SL",
          "Order No",
          "Buyer Name",
          "Shipper Name",
          "Total CBM",
          "Invoice No",
          "Delivery Date",
          "Invoice Value",
          "Advance",
          "Total Paid",
          "Payment Date",
          "Total Due",
          "Aging (Days)",
          "Next Payment Date"
        ]
      ];

      let serialNumber = 1;

      this.reportData.forEach(item => {
        const invoice = item.sale_invoices || {};
        const delivery = invoice.sale_delivery || {};
        const payment = invoice.customer_payments_latest || {};

        const aging = this.getDaysAgo(item.sale_invoices);

        data.push([
          serialNumber++,                          // #SL
          item.code || '-',                        // Order No
          item.shop_name || '-',                   // Buyer Name
          item.shipper_company_name || '-',        // Shipper Name
          item.total_cbm || 0,                     // Total CBM
          invoice.code || '-',                     // Invoice No
          delivery.delivery_date || '-',           // Delivery Date
          item.total || 0,                         // Invoice Value
          item.paid || 0,                          // Advance
          item.total_paid || 0,                    // Total Paid
          payment.payment_date || '-',             // ✅ Payment Date (FIXED)
          item.due_amount || 0,                    // Total Due
          aging || 0,                              // Aging (Days)
          item.next_payment_date || '-'            // Next Payment Date
        ]);
      });

      this.$exportTableToExcel(
        data,
        "outstanding_report_" + this.$fileDate()
      );
    },
    exportToCSV() {
      var data = [
        [ "#SL", "Code", "Company Name", "Company Email", "Company Phone", "Total", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.company_name, item.company_email, item.company_phone, item.grand_total, item.status == 1 ? "Active" : "Inactive" ]);
      });

      this.$exportTableToCSV(data, "sale_statement_reports_" + this.$fileDate());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
